import React, { useEffect } from 'react';
import { Button, Modal } from 'react-bootstrap';
import {useTranslation} from 'react-i18next';

const AlertDialog = (props) => {

  const [open, setOpen] = React.useState(true);
  const [header, setHeader] = React.useState('?');
  const [message, setMessage] = React.useState('?'); 
  const [t] = useTranslation();    
   

  const handleClose = () => {
    clickedOn('CANCEL');
    setOpen(false);    
  };

  const handleOk = () => {
    clickedOn('OK');
    setOpen(false);    
  };

  const clickedOn = (value) => {
    props.parentCallback(value);
  }

  useEffect(() => {
    setOpen(props.open);    
    setHeader(props.header);    
    setMessage(props.message);    
  }, [props])


  


  return (
      
    <div className="modal-alert">     
      <Modal
        show={open}        
        aria-labelledby="modal-alert"
        onHide={handleClose}
        container={this}     
        centered
        size="sm"
        >
          <Modal.Header closeButton>
                      <Modal.Title id="contained-modal-title">{header}</Modal.Title>
          </Modal.Header>
                    <Modal.Body>
                                
                          <div className="col-12">
                                {message}
                         </div>                                                        
                    </Modal.Body>
                    <Modal.Footer>                                                    
                          <Button className="btn-primary" onClick={handleOk}>{t('general.button.ok')}</Button>    
                          <Button className="btn-default" onClick={handleClose}>{t('general.button.cancel')}</Button>
                    </Modal.Footer>
                                       
      </Modal>
    </div>
  );
};


export default AlertDialog;